module.exports = __webpack_public_path__ + "static/media/empowermgmt.542ecc7a.svg";